import React from "react";
import "./Clinicians.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import config from "./Clinicians.json";
import { cdnUrl } from "../../config/cdn";

const SideBySideSection = ({ title, content, bgColor, textColor, leftFlex, rightFlex, gap }) => {
  return (
    <section className="side-by-side-section" style={{ backgroundColor: bgColor, color: textColor, gap }}>
      <div className="side-left" style={{ flex: leftFlex }}>
        <h2 className="side-heading" dangerouslySetInnerHTML={{ __html: title }} />
      </div>
      <div className="side-right" style={{ flex: rightFlex }}>
        <p className="side-text">{content}</p>
      </div>
    </section>
  );
};

const FeatureBlock = ({ image, title, content, reverse }) => {
  return (
    <section className={`feature-block ${reverse ? "reverse" : ""}`}>
      <div className="feature-img">
        <img src={image} alt="section" />
      </div>
      <div className="feature-text">
        <h2 dangerouslySetInnerHTML={{ __html: title }} />
        <p>{content}</p>
      </div>
    </section>
  );
};

const Clinicians = () => {
  const { hero, section1, featureBlock, outcomesSection, testimonials, formSection } = config;

  return (
    <>
      {/* HERO SECTION */}
      <header
        className="hero-section"
        style={{ backgroundImage: `url('${cdnUrl(hero.background)}')` }}
      >
        <div className="hero-content">
          <h1 dangerouslySetInnerHTML={{ __html: hero.title }} />
        </div>
      </header>

      <SideBySideSection
        title={section1.title}
        content={section1.content}
      />

      <FeatureBlock
        image={cdnUrl(featureBlock.image)}
        reverse={true}
        title={featureBlock.title}
        content={featureBlock.content}
      />

      {/* OUTCOMES SECTION */}
      <section className="outcomes-section">
        <h2 dangerouslySetInnerHTML={{ __html: outcomesSection.title }} />
        <p className="outcome-subtext">{outcomesSection.subtitle}</p>

        <div className="outcomes-cards">
          {outcomesSection.cards.map((card, i) => (
            <div className={`outcome-card fade-in delay-${i}`} key={i}>
              <img src={cdnUrl(card.image)} className="outcome-icon" alt="outcome" />
              <h3>{card.value}</h3>
              <span>{card.subValue}</span>
              <p>{card.description}</p>
            </div>
          ))}
        </div>
      </section>

      {/* TESTIMONIALS */}
      <section className="testimonial-section">
        <h2>{testimonials.title}</h2>

        {testimonials.items.map((t, i) => (
          <div className="testimonial-slider" key={i}>
            <p className="quote">"{t.quote}"</p>
            <h4>{t.author}</h4>
          </div>
        ))}
      </section>

      {/* FORM SECTION */}
      <section className="form-section">
        <h2 dangerouslySetInnerHTML={{ __html: formSection.title }} />
        <p>{formSection.subtitle}</p>

        <form>
          <input type="text" placeholder={formSection.fields.name} />
          <input type="email" placeholder={formSection.fields.email} />
          <input type="text" placeholder={formSection.fields.phone} />
          <input type="text" placeholder={formSection.fields.hospital} />

          <label>{formSection.fields.facilityTypeLabel}</label>
          <select>
            <option>{formSection.fields.facilityPlaceholder}</option>
            {formSection.fields.facilityOptions.map((opt, i) => (
              <option key={i}>{opt}</option>
            ))}
          </select>

          <textarea placeholder={formSection.fields.message} rows="5"></textarea>

          <button className="primary-btn">{formSection.submitButton}</button>
        </form>
      </section>
    </>
  );
};

export default Clinicians;
